import axios from "axios";
import {Storage} from "@/Services/Storage";
import queryStringify from "qs-stringify";

export default {
    name: 'stock-take',
    state: {

    },
    getters: {

    },
    mutations: {

    },
    actions: {
        searchStockTakes: (context , payload) => {
            let range= context.getters.getGlobalDateRange;
            range.From+=` 00:00:00`;
            range.To+=` 23:59:59`;
            payload = { ...payload, ...range }
            return axios.get(wareHouseTomcatApi+`StockTake/search`,{ params : payload })
                .then(({data})=>data).catch(err=>errorHandler.tomcatError(err));
        },
        createStockTake : async (context , payload) => {
            let user = await Storage.getCurrentUser();
            payload = { ...payload , createdUser : user.Username }
            return axios.post(wareHouseTomcatApi+`StockTake`,payload)
                .catch(err=>errorHandler.tomcatError(err))
        },
        getAllActiveBins:(context , payload)=> {
            return axios.post(wareHouseTomcatApi + `bin/search`,payload)
                .then(({data}) =>data).catch(err => errorHandler.tomcatError(err))
        },

        editStockTake:async (context , payload) => {
            return axios.post(wareHouseTomcatApiC+`count`,payload)
                .catch(err=>errorHandler.tomcatError(err));
        },

        getItemsByBin:(context , binID)=> {
            return axios.get(wareHouseTomcatApi + `bin/getBinById?id=`+binID,)
                .then(({data}) =>data).catch(err => errorHandler.tomcatError(err))
        },
        getStockTakeByID:(context , id)=> {
            return axios.get(wareHouseTomcatApi + `StockTake/searchById?id=${id}`)
                .then(({data}) =>data).catch(err => errorHandler.tomcatError(err))
        },
        getStockTakeItems:(context , id)=> {
            return axios.get(wareHouseTomcatApi + `stockTakeItems/getAll/${id}`)
                .then(({data}) =>data).catch(err => errorHandler.tomcatError(err))
        },
        recountItems :(context , payload)=> {
            return axios.post(wareHouseTomcatApi + `recount/doRecount`,payload)
                .catch(err => errorHandler.tomcatError(err))
        },

        recountBin :(context , payload)=> {
            return axios.post(wareHouseTomcatApi + `recount/doRecountBin`,payload)
                .catch(err => errorHandler.tomcatError(err))
        },

        exportVariance :(context , stockTake)=> {
            return openUrl(wareHouseTomcatApi+`stockTakeReport/variance?id=`+stockTake)
        },

        exportUncounted :(context , obj)=> {
            obj = `?${queryStringify(obj)}`;
            return openUrl(wareHouseTomcatApi+`stockTakeReport/itemsNotCounted`+obj);
        },

        exportItemHistory :(context , obj)=> {
            obj = `?${queryStringify(obj)}`;
            return openUrl(wareHouseTomcatApi+`stockTakeReport/itemCountByBin`+obj);
        },
        exportAllItemHistory :(context , stockTakeID)=> {
            stockTakeID = `?stockTakeID=${stockTakeID}`;
            return openUrl(wareHouseTomcatApi+`stockTakeReport/allItemCountByBin`+stockTakeID);
        },

        exportStockTakeOrder :async (context , stockTake)=>  {
            let user  = await Storage.getCurrentUser();
            user = user.Username;
            return openUrl(wareHouseTomcatApi+`stockTakeReport/downloadNavisionSheet?id=`+stockTake+`&user=`+user)
        },

        exportBinVariance :(context , binID)=> {
            return openUrl(wareHouseTomcatApi+`stockTakeReport/bin?id=`+binID)
        },

        setNavQuantities:async (context , storeID)=>{
            let user = await Storage.getCurrentUser();
            let obj = {
                type : `one`,
                navID : storeID,
                user : user.Username
            }
            return axios.post(wareHouseTomcatApi+`count/setNavQuantities`,obj)
                .catch(err=>errorHandler.tomcatError(err))
        },

        processStockTake: async (context , payload) => {
            let user = await Storage.getCurrentUser();
            payload = {
                ...payload,
                user: user.Username
            }
            return axios.post(wareHouseTomcatApi+`StockTake/processStockTake`,payload)
                .catch(err=>errorHandler.tomcatError(err))
        }
    }
}
